import { GameObjects } from 'phaser';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { MolduraPixel } from './MolduraPixel';

const ESTADOS = {
    normal: { fundo: ARCADE_HEX.BRANCO, fio: ARCADE_HEX.FIO_CAMPO, fioMeio: ARCADE_HEX.BRANCO, texto: '#1a1a1a' },
    selecionada: { fundo: 0xc3dbff, fio: 0x6f9cdd, fioMeio: 0xc3dbff, texto: '#263e60' },
    correta: { fundo: 0xcbff61, fio: ARCADE_HEX.VERDE, fioMeio: 0xcbff61, texto: '#29561a' },
    errada: { fundo: 0xffa1a1, fio: 0xb55858, fioMeio: 0xffa1a1, texto: '#821b1b' },
    bloqueada: { fundo: 0x8f8f8f, fio: 0x3a3a3a, fioMeio: 0x8f8f8f, texto: '#1a1a1a' }
};

/**
 * Alternativa de múltipla escolha (Figma, quadros 67, 70 e 71): cartão de
 * moldura pixel com a letra em Silkscreen e o texto em Barlow.
 */
export class CartaoOpcao extends GameObjects.Container {
    constructor (scene, x, y, { letra, texto, largura = 570, altura = 122, aoTocar = null, centrado = false, caixa = false, sufixo = ')', larguraTexto = null }) {
        super(scene, x, y);
        scene.add.existing(this);
        this.largura = largura;
        this.altura = altura;
        this.estado = 'normal';

        this.moldura = scene.add.graphics();
        this.letra = scene.add.text(35, 38, `${letra}${sufixo}`, ARCADE_TEXT.letraOpcao).setOrigin(0, 0.5);
        // O texto começa depois da letra: espaços duros reservam o recuo da 1ª linha.
        const recuo = ' '.repeat(Math.ceil((this.letra.width + 8) / 4.1));
        // Opcional: `centrado` (texto no meio da altura) e `caixa` (caixinha de seleção à direita).
        this.texto = scene.add.text(33, centrado ? altura / 2 : 26, `${recuo}${texto}`, {
            ...ARCADE_TEXT.opcao, wordWrap: { width: larguraTexto ?? largura - (caixa ? 100 : 64) }
        });
        if (centrado) {
            this.texto.setOrigin(0, 0.5);
            const linhas = Math.max(1, this.texto.getWrappedText().length);
            this.letra.y = this.texto.y - this.texto.height / 2 + this.texto.height / linhas / 2;
        }
        this.add([this.moldura, this.letra, this.texto]);

        if (caixa) {
            this.caixa = scene.add.graphics();
            this.caixaX = largura - 34;
            this.caixaY = altura / 2;
            this.add(this.caixa);
            this.setMarcada(false);
        }

        this.setSize(largura, altura);
        this.zona = scene.add.zone(largura / 2, altura / 2, largura, altura)
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => this.zona.input.enabled && aoTocar?.(this));
        this.add(this.zona);

        this.setEstado('normal');
    }

    /** Caixinha de seleção (só nos cartões criados com `caixa`). */
    setMarcada (marcada) {
        if (!this.caixa) return this;
        const lado = 22;
        this.caixa.clear()
            .fillStyle(marcada ? 0xc3dbff : ARCADE_HEX.BRANCO, 1)
            .fillRoundedRect(this.caixaX - lado / 2, this.caixaY - lado / 2, lado, lado, 5)
            .lineStyle(2.6, marcada ? 0x5487d3 : ARCADE_HEX.TINTA, 1)
            .strokeRoundedRect(this.caixaX - lado / 2, this.caixaY - lado / 2, lado, lado, 5);
        return this;
    }

    setEstado (estado) {
        this.estado = ESTADOS[estado] ? estado : 'normal';
        const cores = ESTADOS[this.estado];
        this.moldura.clear();
        MolduraPixel.desenhar(this.moldura, 0, 0, this.largura, this.altura, cores, { esq: true, dir: true, tamanho: 13 });
        this.letra.setColor(cores.texto);
        this.texto.setColor(cores.texto);
        return this;
    }

    /** Depois de conferida (ou no tablet de quem não responde), a alternativa não aceita toque. */
    setTocavel (tocavel) {
        this.zona.input.enabled = tocavel;
        return this;
    }
}
